/*
 * GMAN Stock Up ladder (snippets/gman-stock-up.liquid).
 * The tiers are a quantity picker for the theme's own product form:
 * picking "2 packs" sets #Quantity-<section> to 2, so Add to cart adds 2 packs
 * of whatever variant the main color/size picker has selected.
 * Prices, per-shirt math and notes follow the selected variant.
 */
(function () {
  if (customElements.get('gman-stock-up')) return;
  /* UI text: window.GMAN_T comes from snippets/gman-i18n.liquid (locale keys gman.js.*). The English fallback keeps the store working if that snippet is missing. */
  function T(k, en, vars) {
    var s = window.GMAN_T && window.GMAN_T[k] != null ? window.GMAN_T[k] : en;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  }

  function money(cents) { return '$' + ((cents || 0) / 100).toFixed(2); }

  function track(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, data || {}));
    } catch (e) { /* analytics must never break the buy box */ }
  }

  class GmanStockUp extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.product = JSON.parse(this.querySelector('[data-su-product]').textContent); } catch (e) { return; }
      this.sectionId = this.dataset.section;
      this.threshold = parseInt(this.dataset.threshold, 10) || 5000;
      this.discount = parseFloat(this.dataset.discount) || 0;
      this.units = this.product.unitsPerPack || 1;
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('[data-packs]'));
      this.summary = this.querySelector('[data-su-summary]');
      this.form = document.getElementById('product-form-' + this.sectionId);
      this.qty = this.findQty();
      this.variantId = this.readVariantId();

      this.tiers.forEach((t) => {
        t.addEventListener('click', () => this.pick(parseInt(t.dataset.packs, 10), true));
        t.addEventListener('keydown', (e) => this.onKey(e, t));
      });
      var bulk = this.querySelector('[data-su-bulk]');
      if (bulk) bulk.addEventListener('click', () => track('gman_stock_up_bulk', { product_id: this.product.id }));

      // main variant picker writes the new id into the form's hidden input and fires change
      this._onChange = (e) => {
        var tg = e.target;
        if (!tg) return;
        if (tg.name === 'id' && this.form && (tg.form === this.form || this.form.contains(tg))) {
          this.variantId = parseInt(tg.value, 10) || this.variantId;
          this.render();
        } else if (tg === this.qty) {
          this.syncFromQty();
        }
      };
      document.addEventListener('change', this._onChange);
      if (this.qty) this.qty.addEventListener('input', () => this.syncFromQty());

      var def = parseInt(this.dataset.default, 10) || 1;
      this.pick(def, false);
    }

    disconnectedCallback() {
      if (this._onChange) document.removeEventListener('change', this._onChange);
    }

    findQty() {
      var q = document.getElementById('Quantity-' + this.sectionId);
      if (q) return q;
      // theme without a quantity selector: add a hidden one the form will submit
      if (!this.form) return null;
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      q.value = '1';
      this.form.appendChild(q);
      return q;
    }

    readVariantId() {
      var input = this.form && this.form.querySelector('input[name="id"]');
      var id = input ? parseInt(input.value, 10) : 0;
      return id || this.product.selectedId || (this.product.variants[0] && this.product.variants[0].id);
    }

    variant() {
      var id = this.variantId;
      for (var i = 0; i < this.product.variants.length; i++) {
        if (this.product.variants[i].id === id) return this.product.variants[i];
      }
      return this.product.variants[0];
    }

    totalFor(packs, price) {
      var t = price * packs;
      if (packs >= 4 && this.discount > 0) t = t - Math.round(t * this.discount / 100);
      return t;
    }

    pick(packs, user) {
      this.packs = packs;
      if (this.qty) {
        this.qty.value = String(packs);
        this.qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.render();
      if (user) track('gman_stock_up_select', { packs: packs, product_id: this.product.id, variant_id: this.variantId });
    }

    syncFromQty() {
      var n = parseInt(this.qty.value, 10) || 1;
      if (n === this.packs) return;
      this.packs = n;
      this.render();
    }

    onKey(e, t) {
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(e.key in keys)) return;
      e.preventDefault();
      var i = this.tiers.indexOf(t) + keys[e.key];
      if (i < 0) i = this.tiers.length - 1;
      if (i >= this.tiers.length) i = 0;
      this.tiers[i].focus();
      this.pick(parseInt(this.tiers[i].dataset.packs, 10), true);
    }

    render() {
      var v = this.variant();
      var price = v ? v.price : 0;
      var units = this.units;
      var self = this;
      this.tiers.forEach(function (t) {
        var packs = parseInt(t.dataset.packs, 10);
        var total = self.totalFor(packs, price);
        var on = packs === self.packs;
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.querySelector('[data-su-total]').textContent = money(total);
        var unitsEl = t.querySelector('[data-su-units]');
        var eachEl = t.querySelector('[data-su-each]');
        if (units > 1) {
          unitsEl.textContent = T('su_shirts', '{n} shirts', { n: packs * units });
          eachEl.textContent = T('su_each', '{price} each', { price: money(Math.round(total / (packs * units))) });
        } else {
          unitsEl.textContent = (packs === 1 ? T('su_item', '{n} item', { n: packs }) : T('su_items', '{n} items', { n: packs }));
          eachEl.textContent = '';
        }
        var note = t.querySelector('[data-su-note]');
        var free = total >= self.threshold;
        var saving = packs >= 4 && self.discount > 0;
        note.textContent = saving ? (T('su_save', 'Save {pct}%', { pct: self.discount }) + (free ? T('su_save_free', ', ships free') : '')) : (free ? T('su_ships_free', 'Ships free') : T('su_plus_shipping', '+ shipping'));
        note.classList.toggle('gman-su__note--good', free || saving);
      });
      // nothing pressed when the customer typed a quantity we don't show (3, 5, 9...)
      if (!this.tiers.some(function (t) { return t.getAttribute('aria-checked') === 'true'; }) && this.tiers[0]) this.tiers[0].tabIndex = 0;

      if (this.summary) {
        var n = this.packs;
        var total = this.totalFor(n, price);
        var label = (n === 1 ? T('su_pack', '{n} pack', { n: n }) : T('su_packs', '{n} packs', { n: n })) + (units > 1 ? ' (' + T('su_shirts', '{n} shirts', { n: n * units }) + ')' : '');
        var ship = total >= this.threshold ? T('su_ships_free_dot', 'Ships free.') : T('su_threshold', 'Orders of {amount} and up ship free.', { amount: money(this.threshold) });
        this.summary.textContent = T('su_summary', 'Add to cart adds {label}, {total}. {ship}', { label: label, total: money(total), ship: ship });
      }
    }
  }

  customElements.define('gman-stock-up', GmanStockUp);
})();
